import { Config } from "./types";

const defaultConfig: Config = {
	codeCopy: {
		buttonClass: 'v-icon theme--dark'
	}
};

export { defaultConfig };
